import { render, staticRenderFns } from "./main-service-provider.vue?vue&type=template&id=5b6604f2&scoped=true&"
import script from "./main-service-provider.vue?vue&type=script&lang=js&"
export * from "./main-service-provider.vue?vue&type=script&lang=js&"
import style0 from "./main-service-provider.vue?vue&type=style&index=0&id=5b6604f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6604f2",
  null
  
)

export default component.exports